import IPCIDR from 'ip-cidr';
import { ASN, getData, Prefix } from './common';

interface AnnouncedPrefixes {
  prefixes?: { prefix: string }[];
}

export async function getAnnouncedPrefixes(asn: ASN): Promise<Prefix[]> {
  const result = await getData<AnnouncedPrefixes>('announced-prefixes', {
    resource: asn.toString(),
  });

  return sortPrefixList(result.prefixes?.map((prefixObject) => prefixObject.prefix) ?? []);
}

const sortPrefixList = (prefixesToOrder: string[]): string[] => {
  const orderedPrefixList = prefixesToOrder
    .map((prefix) => {
      const cidr = new IPCIDR(prefix);
      //@ts-ignore
      const start = cidr.start({ type: 'bigInteger' });
      //@ts-ignore
      const end = cidr.end({ type: 'bigInteger' });

      return {
        prefix,
        start,
        end,
      };
    })
    .sort((a, b) => {
      if (a.start < b.start) {
        return -1;
      }
      if (a.start > b.start) {
        return 1;
      }

      if (a.end > b.end) {
        return -1;
      }
      if (a.end < b.end) {
        return 1;
      }

      return 0;
    });

  return orderedPrefixList.map((prefixWithAddedData) => prefixWithAddedData.prefix);
};
